import React, { useState } from 'react';
import Dashboard from './screens/Dashboard';
import LogEntry from './screens/LogEntry';
import RecordBook from './screens/RecordBook';

const NAV = [
  { id: 'dashboard', label: 'Family', icon: HomeIcon },
  { id: 'log',       label: 'Log',    icon: PlusIcon },
  { id: 'record',    label: 'Record Book', icon: BookIcon },
];

export default function App() {
  const [screen, setScreen] = useState('dashboard');

  const screens = {
    dashboard: <Dashboard onNavigate={setScreen} />,
    log:       <LogEntry  onNavigate={setScreen} />,
    record:    <RecordBook onNavigate={setScreen} />,
  };

  return (
    <div style={styles.shell}>
      {/* Top bar */}
      <div style={styles.topBar}>
        <div>
          <div style={styles.wordmark}>
            <span style={{color:'#fff'}}>Clover</span>
            <span style={{color:'var(--forest-pale)'}}>Track</span>
          </div>
          <div style={styles.byLine}>by RiverHouse Farms</div>
        </div>
        <div style={styles.topRight}>
          <div style={styles.tierBadge}>FAMILY</div>
          <div style={styles.avatar}>DP</div>
        </div>
      </div>

      {/* Screen */}
      <div style={styles.content} key={screen}>
        <div className="fade-up" style={{flex:1, overflowY:'auto'}}>
          {screens[screen]}
        </div>
      </div>

      {/* Bottom nav */}
      <div style={styles.bottomNav}>
        {NAV.map(n => (
          <button key={n.id} style={styles.navItem(screen === n.id)} onClick={() => setScreen(n.id)}>
            <n.icon active={screen === n.id} />
            <span style={styles.navLabel(screen === n.id)}>{n.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

const styles = {
  shell: {
    maxWidth: 430,
    margin: '0 auto',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: 'var(--surface)',
    position: 'relative',
  },
  topBar: {
    background: 'var(--forest-primary)',
    padding: '14px 16px 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  wordmark: {
    fontFamily: 'var(--ff-display)',
    fontSize: 18,
    letterSpacing: '0.01em',
  },
  byLine: {
    fontFamily: 'var(--ff-sans)',
    fontSize: 10,
    color: 'var(--warm-white)',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    marginTop: 1,
  },
  topRight: { display: 'flex', alignItems: 'center', gap: 10 },
  tierBadge: {
    background: 'var(--burg)',
    borderRadius: 6,
    padding: '3px 8px',
    fontSize: 10,
    fontWeight: 600,
    color: '#fff',
    letterSpacing: '0.04em',
  },
  avatar: {
    width: 30, height: 30,
    borderRadius: '50%',
    background: 'var(--forest-mid)',
    border: '1.5px solid var(--forest-light)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 11, fontWeight: 600, color: 'var(--forest-pale)',
  },
  content: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    background: 'var(--bg-page)',
  },
  bottomNav: {
    background: 'var(--forest-sidebar)',
    padding: '8px 0 12px',
    display: 'flex',
    justifyContent: 'space-around',
    flexShrink: 0,
  },
  navItem: (active) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 3,
    background: active ? 'rgba(255,255,255,0.09)' : 'transparent',
    border: 'none',
    borderRadius: 8,
    padding: '5px 18px',
    transition: 'background 0.15s',
  }),
  navLabel: (active) => ({
    fontSize: 10,
    color: active ? '#fff' : 'var(--warm-white)',
    letterSpacing: '0.04em',
    fontWeight: active ? 500 : 400,
  }),
};

function HomeIcon({ active }) {
  const c = active ? '#fff' : 'var(--warm-white)';
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" stroke={c} strokeWidth="1.8"/>
      <path d="M9 22V12h6v10" stroke={c} strokeWidth="1.8"/>
    </svg>
  );
}
function PlusIcon({ active }) {
  const c = active ? '#fff' : 'var(--warm-white)';
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke={c} strokeWidth="1.8"/>
      <path d="M12 8v8M8 12h8" stroke={c} strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  );
}
function BookIcon({ active }) {
  const c = active ? '#fff' : 'var(--warm-white)';
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M6 2h12a2 2 0 012 2v16a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2z" stroke={c} strokeWidth="1.8"/>
      <path d="M9 7h6M9 11h6M9 15h4" stroke={c} strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  );
}
